import styled from 'styled-components';
import { generateContentIconStyle } from '../../icons';

export const StyledCarousel = styled.div`
  padding: 0 ${props => props.theme.spacing(4)};
  display: flex;
  position: relative;
`;

export const Button = styled.button`
  background: ${props => props.theme.colors.text.primary};
  border: 2px solid ${props => props.theme.colors.text.primary};
  border-radius: 60%;
  padding: 0px;
  width: 50px;
  height: 50px;
  position: ${props => (props.overlappingArrows ? 'absolute' : 'unset')};
  top: ${props => props.buttonPosition}%;
  transform: translateY(
    ${props => (props.overlappingArrows ? props.buttonPosition - 100 : '0')}%
  );
  right: ${props => (props.arrowType === 'right' ? '10px' : 'unset')};
  left: ${props => (props.arrowType === 'left' ? '10px' : 'unset')};
  z-index: 10;
  &::before {
    top: 2px;
    position: relative;
    ${props =>
      props.arrowType === 'right'
        ? generateContentIconStyle('arrow-forward')
        : generateContentIconStyle('arrow-left')};
    width: 21px;
    height: 21px;
    background: ${props => props.theme.colors.background.lightest};
  }
  :focus {
    border: 2px solid ${props => props.theme.colors.text.primary};
  }
  :hover:not([disabled]) {
    background: ${props => props.theme.colors.text.primary};
    border: 2px solid ${props => props.theme.colors.text.primary};
  }
  &:disabled {
    display: none;
  }
`;
export const ButtonContainer = styled.div`
  display: flex;
  max-width: 32px;
  height: 100%;
  align-items: center;
`;

export const DotContainer = styled.div`
  margin-bottom: ${props => props.theme.spacing(9)};
`;

export const BottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: ${props => props.theme.spacing(props.dotPadding)};
`;
